(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('PasswordResetInit', PasswordResetInit);

  PasswordResetInit.$inject = ['$resource', 'API_URI'];

  function PasswordResetInit($resource, API_URI) {
    return $resource(API_URI + 'api/account/reset_password/init', {}, {});
  }
})();
